/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lower pressure means a lower, gentler boiling point.`)
};

const es_bp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menor presión implica un punto de ebullición más bajo y suave.`)
};

const de_bp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedrigerer Druck bedeutet einen niedrigeren, schonenderen Siedepunkt.`)
};

const nl_bp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lagere druk betekent een lager, zachter kookpunt.`)
};

const fr_bp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une pression plus basse signifie un point d'ébullition plus bas et plus doux.`)
};

const it_bp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una pressione più bassa significa un punto di ebollizione più basso e delicato.`)
};

const pt_br2_bp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressão mais baixa significa um ponto de ebulição mais baixo e mais suave.`)
};

const pt_bp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressão mais baixa significa um ponto de ebulição mais baixo e suave.`)
};

const ja_bp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧力が低いほど、沸点は低く穏やかになります。`)
};

const zh_bp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`压力越低，沸点越低、越温和。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_ex2", locale)
	if (locale === "en") return en_bp_ex2(inputs)
	if (locale === "es") return es_bp_ex2(inputs)
	if (locale === "de") return de_bp_ex2(inputs)
	if (locale === "nl") return nl_bp_ex2(inputs)
	if (locale === "fr") return fr_bp_ex2(inputs)
	if (locale === "it") return it_bp_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_bp_ex2(inputs)
	if (locale === "pt") return pt_bp_ex2(inputs)
	if (locale === "ja") return ja_bp_ex2(inputs)
	return zh_bp_ex2(inputs)
};